import * as types from '@/store/mutation-types'

const state = {
  loading: false,
  fullPage: true
}

const getters = {
  isLoading: state => state.loading,
  isFullPage: state => state.fullPage
}

const actions = {
  start ({ commit }) {
    commit(types.START_LOADING)
  },
  stop ({ commit }) {
    commit(types.STOP_LOADING)
  },
  fullScreen ({ commit }) {
    commit(types.APPLY_FULLSCREEN)
  },
  onlyComponent ({ commit }) {
    commit(types.APPLY_COMPONENT)
  }
}

const mutations = {
  [types.START_LOADING] (state) {
    state.loading = true
  },
  [types.STOP_LOADING] (state) {
    state.loading = false
  },
  [types.APPLY_FULLSCREEN] (state) {
    state.fullPage = true
  },
  [types.APPLY_COMPONENT] (state) {
    state.fullPage = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/loading.js